import { generateVolumeSteps } from "../../../../config/audio/radioConfig";
import { RadioName, RadioState } from "../../../../config/audio/types";
import { toPercent } from "../../../utils/utils";
import VolumeLevelBar from "./VolumeLevelBar";

interface Props {
	radioName: RadioName;
	radioState: RadioState;
}

export default function RadioVolumeItem({ radioName, radioState }: Props) {
	const sceneVolume = radioState.gain;
	const steps = generateVolumeSteps(radioState.config);
	const maxStep = steps.length - 1;
	const effectiveVolume = sceneVolume * steps[radioState.volumeLevel];

	return (
		<div className="mb-4 pb-4 border-b border-white/10">
			<div className="flex justify-between items-start mb-3">
				<div className="flex flex-col">
					<span
						className={`font-semibold text-lg ${radioState.isOn ? "text-green-300" : "text-gray-400"}`}
					>
						{radioName} {radioState.isOn ? "(ON)" : "(OFF)"}
					</span>
					<span
						className={`font-normal text-base leading-tight ${radioState.isOn ? "text-green-200" : "text-gray-500"}`}
					>
						{radioState.station}
					</span>
				</div>
				<div className="text-right space-y-1">
					<div className="text-base text-blue-300 leading-tight">
						scene: {toPercent(sceneVolume)}%
					</div>
					<div className="text-base font-bold text-green-300 leading-tight">
						level_gain: {toPercent(steps[radioState.volumeLevel])}%
					</div>
					{sceneVolume > 0 && (
						<div className="text-base text-yellow-300 leading-tight">
							out: {toPercent(effectiveVolume)}%
						</div>
					)}
				</div>
			</div>
			<div className="flex mt-3">
				<div className="flex-1">
					<div
						className={`text-sm mb-1 font-medium ${radioState.isOn ? "text-green-300" : "text-gray-400"}`}
					>
						Volume Level
					</div>
					<VolumeLevelBar level={radioState.volumeLevel} maxStep={maxStep} />
				</div>
			</div>
		</div>
	);
}
